<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="pa-0">
        <v-toolbar v-if="$route.params.deviceId" class="add-opacity" color="backgroundLight" :flat="true">
          <v-toolbar-title class="title primaryGrey--text">
            <router-link :to="`/scavenger`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>{{ $t("common.words.back") }}
            </router-link>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3" v-if="$route.params.deviceId">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  dense
                  :value="computed_as_of"
                  append-icon="mdi-calendar"
                  readonly
                  label="As of"
                ></v-text-field>
              </template>
              <v-date-picker v-model="as_of" @change="update_data_asof"></v-date-picker>
            </v-menu>
          </v-col>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="page_content && device_data" class="common-card-row">
      <v-col cols="12" :md="!use_arcgis ? 8 : 6" class="pa-0 pr-md-3">
        <v-col class="common-card-col">
          <v-row>
            <v-col cols="12" class="font-weight-bold titleLight--text">
              <v-row no-gutters class="text-h6 font-weight-bold titleLight--text">
                <v-col cols="8">
                  <span v-for="(value, key) in page_content.device_details_title" :key="key">
                    <transition name="fade" mode="out-in">
                      <span v-if="device_data[value]" :key="device_data[value]" :data-testid="`page-title-${value}`">
                        {{ device_data[value] }}
                      </span>
                    </transition>
                    <!-- <span v-if="device_data[value]">/</span> -->
                  </span>
                  <v-icon
                    v-if="$route.params.deviceId && !is_readonly_user"
                    color="primary"
                    class="pl-2 pb-1 pointer"
                    title="Edit Device Details"
                    @click="
                      dialog = true;
                      overlay_type = 'edit';
                    "
                    small
                    >mdi-pencil</v-icon
                  >
                  <v-icon
                    v-if="$route.params.deviceId"
                    color="vtred"
                    class="pl-2 pb-1 pointer"
                    title="Create alert"
                    small
                    @click="openNewAlertsDialog"
                    >mdi-bell-plus</v-icon
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="text-body-2 font-weight-bold">
                  <router-link class="no-style mr-3" target="_blank" :to="redirectProps.redirect_route">
                    {{ redirectProps.redirect_label
                    }}<v-icon
                      color="vtred"
                      class="pl-2 pb-1 pointer"
                      :title="`Open ${redirectProps.redirect_label} in new tab`"
                      small
                      >mdi-open-in-new</v-icon
                    >
                  </router-link>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div v-if="device_data.CurrentLat" class="d-flex mt-1 text-caption primaryGrey--text">
                    <div>
                      <v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon
                      ><transition name="fade" mode="out-in" leave-absolute
                        ><span :key="device_data.CurrentLat">{{ device_data.CurrentLat }}</span></transition
                      >
                    </div>
                    <div class="ml-3">
                      <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon
                      ><transition name="fade" mode="out-in" leave-absolute
                        ><span :key="device_data.CurrentLng">{{ device_data.CurrentLng }}</span></transition
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col
                  cols="4"
                  class="mb-3 titleLight--text"
                  v-for="(data, index) in page_content.device_details"
                  :key="index"
                >
                  <div class="text-caption">
                    {{ data.label }}
                    <TooltipVT v-if="data.tooltip" :text="data.tooltip" :icon="data.icon"></TooltipVT>
                  </div>
                  <transition name="fade" mode="out-in" leave-absolute>
                    <v-icon
                      small
                      v-if="data.icon && device_data[data.value]"
                      :key="`icon-${data.value}-${device_data[data.value]}`"
                    >
                      {{ data.icon }}
                    </v-icon>
                    <span
                      v-else-if="data.type == 'datetime'"
                      :key="`datetime-${data.value}-${device_data[data.value]}`"
                    >
                      {{ device_data[data.value] | date }}
                    </span>
                    <span v-else-if="data.type == 'date'" :key="`date-${data.value}-${device_data[data.value]}`">
                      {{ $dateFormat(device_data[data.value]) }}
                    </span>
                    <span v-else-if="data.type == 'multi'" :key="`multi-${data.type}`">
                      <span v-for="(key, index) in data.value" :key="`${key.id}`" :class="fadeClass(key)">
                        <span v-if="index != 0" :class="fadeClass(key)">{{ data.join_with }}</span
                        >{{ device_data[key.id] }}
                      </span>
                      <TooltipVT
                        v-if="data.multi_tooltip && missed_message_percentage"
                        :text="missed_message_percentage + data.multi_tooltip"
                        :icon="missed_message_icon"
                        :color="missed_message_color"
                        size="large"
                      />
                    </span>
                    <span
                      v-else-if="data.type == 'tooltip'"
                      :key="`tooltip-${data.value}-${device_data[data.value]}`"
                      :data-testid="`device-details-${data.value}`"
                      >{{ device_data[data.value] }}
                      <TooltipVT
                        v-if="device_data[data.tooltip_value]"
                        :text="getTooltipText(device_data, data)"
                        :icon="data.tooltip_icon"
                        size="large"
                      ></TooltipVT>
                    </span>
                    <span
                      v-else
                      :key="`default-${data.value}-${device_data[data.value]}`"
                      :data-testid="`device-details-${data.value}`"
                    >
                      {{ device_data[data.value] || "-" }}
                    </span>
                  </transition>
                  <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                </v-col>
                <v-col
                  cols="4"
                  class="mb-3 titleLight--text"
                  v-for="(data, index) in page_content.data_call_details"
                  :key="`${index}-data-call-details`"
                >
                  <div class="text-caption">
                    {{ data.label }}
                    <TooltipVT v-if="data.tooltip" :text="data.tooltip" :icon="data.icon"></TooltipVT>
                  </div>
                  <transition name="fade" mode="out-in" leave-absolute>
                    <span
                      :key="`time-${getStateValue(data.transition_on)}`"
                      v-if="getStateValue(data.value)"
                      :data-testid="`data-call-${data.value}`"
                      >{{ getStateValue(data.value) }}</span
                    >
                    <span :key="`no-time-${data.value}`" v-else>-</span>
                  </transition>
                </v-col>
                <span v-show="false" data-testid="data-call-interval">{{ aggregation_period }}</span>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12" md="4" class="pa-0" v-if="!use_arcgis">
        <v-col class="common-card-col">
          <MapsVT
            height="250px"
            :options="page_content.maps_config"
            :infoWindowItemsConfig="page_content.infoWindowItemsConfig"
            :items="map_data"
            :center="get_center"
            :showRoute="!show_info_window"
            :hide_legends="show_info_window"
            :liveStream="true"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="6" class="pa-0" v-else>
        <v-col class="common-card-col">
          <div class="autocon-con">
            <v-btn color="primary" right @click="redirectToAutocon"> AUTOCON</v-btn>
          </div>
          <ArcGIS height="250px" :coordinates="current_coordinates" :liveStream="true" />
        </v-col>
      </v-col>
    </v-row>

    <v-row v-if="device_data && device_data.ActiverFeeders" class="common-card-row">
      <v-col class="common-card-col">
        <v-col cols="12" class="pt-2 pl-3 pb-4">
          <ScavengerH2Insights
            v-if="is_h2_device_type"
            :key="`h2-insights-${latest_message_timestamp}`"
            :device_data="device_data"
          />
          <ScavengerInsights
            v-else
            :key="`insights-${latest_message_timestamp}`"
            :device_details="device_data"
            :as_of="as_of"
            :customer_type="active_tenant"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row v-else class="common-card-row">
      <v-col class="common-card-col">
        <v-skeleton-loader type="image" class="ma-1" />
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <div>
          <PrePrimaryFiltersVT
            :list_filters="tabs"
            @filter_update="update_current_tab($event)"
            :current_tab="current_tab"
          ></PrePrimaryFiltersVT>
        </div>
        <v-row v-if="device_data && device_id" no-gutters class="primaryDark--text">
          <v-col cols="12">
            <div class="mt-3" v-if="current_tab == 'Charts'">
              <ScavengerAssetCharts
                :device_data="device_data"
                :device_id="device_id"
                :as_of="computed_as_of"
                :end_date="previous_message_timestamp"
                :start_date="latest_message_timestamp"
                :realtime_data="charts_data"
                :has_location="has_location"
              />
            </div>
          </v-col>
          <v-col cols="12">
            <div v-if="current_tab == 'Messages' || current_tab == 'Raw Data'">
              <ScavengerAssetMessages
                :device_id="device_id"
                :as_of="computed_as_of"
                :end_date="previous_message_timestamp"
                :start_date="latest_message_timestamp"
                :realtime_data="raw_data"
              />
            </div>
          </v-col>
          <v-col cols="12">
            <div class="mt-3 mx-6 mb-8 primary--text text-subtitle-2" v-if="current_tab == 'Events'">
              <ScavengerAssetEvents :key="latest_message_timestamp" :device_id="device_id" />
            </div>
          </v-col>
          <v-col cols="12">
            <div class="mt-6 mx-12 mb-8 primary--text text-subtitle-2" v-if="current_tab == 'Images'">
              <ImageGallery :device_id="device_id" />
            </div>
          </v-col>
          <v-col cols="12">
            <div class="mt-6 mx-12 mb-8 primary--text text-subtitle-2" v-if="current_tab == 'Reporting'">
              <ScavengerAssetReport :deviceId="device_id" />
            </div>
          </v-col>
          <v-col cols="12">
            <div
              class="mt-3 mx-6 mb-8 primary--text text-subtitle-2"
              v-if="current_tab == 'PQ Events' || current_tab == 'Fault Records' || current_tab == 'XFRMR Health'"
            >
              Coming soon!
            </div>
            <div class="mt-3" v-if="current_tab == 'Trends Data'">
              <ScavengerAssetTrendsData
                :device_id="device_id"
                :active_feeders="active_feeders"
                :end_date="previous_message_timestamp"
                :start_date="latest_message_timestamp"
              />
            </div>
            <div class="mt-3" v-if="current_tab == 'Metering'">
              <ScavengerAssetMetering :key="latest_message_timestamp" :device_id="device_id" />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <CustomOverlay
      v-if="dialog"
      show_header
      background_color="backgroundWhite"
      header_color="backgroundWhite"
      :width="`${overlay_type == 'alert' ? '450px' : '80vw'}`"
      @close="closeDialog"
    >
      <template v-slot:content>
        <EditScvDetails
          @cancel="dialog = false"
          @save="update_assets_details($event)"
          :asset_data="{ item: device_data }"
          v-if="device_data && overlay_type == 'edit'"
        />
        <ScvAlertsTemplate v-if="overlay_type == 'alert'" :device_id="device_id" @close="closeDialog($event)" />
      </template>
    </CustomOverlay>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-container>
</template>

<script>
import { axios_get, axios_post, axios_put } from "../services/vt_service";
import { scv, weather, trafo } from "../services/powerdata";
import { content } from "../../config/scavenger.js";
import { content as h2Content } from "../../config/scavenger_h2.js";
import html2pdf from "html2pdf.js";
import moment from "moment";

import MapsVT from "../components/MapsVT";
import EditScvDetails from "../components/EditScvDetails";
import ScvAlertsTemplate from "../components/ScvAlertsTemplate";
import PrePrimaryFiltersVT from "../components/PrePrimaryFiltersVT";
import ScavengerInsights from "../components/ScavengerInsights";
import ScavengerH2Insights from "../components/ScavengerH2Insights.vue";
import ScavengerAssetCharts from "../components/ScavengerAssetCharts";
import ScavengerAssetMessages from "../components/ScavengerAssetMessages";
import ScavengerAssetTrendsData from "../components/ScavengerAssetTrendsData";
import ScavengerAssetEvents from "../components/ScavengerAssetEvents";
import ScavengerAssetMetering from "../components/ScavengerAssetMetering";
import ImageGallery from "../components/ImageGallery";
import ScavengerAssetReport from "./ScavengerAssetReport";
import ArcGIS from "../components/ArcGIS.vue";
import TooltipVT from "../components/TooltipVT";
import CustomOverlay from "../components/CustomOverlay.vue";
import { scavenger_grpc_services } from "../services/ScavengerServices";

export default {
  props: ["deviceId"],
  watch: {
    deviceId: function () {
      this.getScavengerDetails();
    },
    as_of: function () {
      this.getScavengerDetails();
    },
    latest_message_timestamp: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.last_message_time_display = moment(parseInt(newVal)).fromNow();
        this.previous_message_timestamp = oldVal;
      }
    },
    overview_data: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.network_error = false;
        if (newVal && newVal[0]) {
          this.device_data["UL1"] = newVal[0]["UL1"];
          this.device_data["UL2"] = newVal[0]["UL2"];
          this.device_data["UL3"] = newVal[0]["UL3"];
        }
      }
    },
    scavenger_data: function (newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.$route.params && this.$route.params.deviceId) {
          this.no_search = false;
          this.device_id = this.$route.params.deviceId;
          this.$store.commit("clear_search");
          // this.$store.commit("update_page_title", `Device / ${this.device_id}`);
        } else {
          this.device_id = this.deviceId;
        }
        this.device_data = this.compareData(newVal.length > 0 ? newVal[0] : {});
        // Aggregation period is in minutes, so converting it to milliseconds
        this.aggregation_period = this.device_data.AggregationPeriod //to understand how when and why agg period changes, and what to do when it does.
          ? this.device_data.AggregationPeriod * 60000 + 3000
          : 63000;
        this.active_feeders = this.device_data.ActiverFeeders ? this.device_data.ActiverFeeders.toString() : null;
        this.latest_message_timestamp = this.getMessageTimestamp();
      }
    },
  },
  name: "ScavengerAsset",
  components: {
    MapsVT,
    EditScvDetails,
    PrePrimaryFiltersVT,
    ScavengerInsights,
    ScavengerH2Insights,
    ScavengerAssetCharts,
    ScavengerAssetMessages,
    ScavengerAssetTrendsData,
    ScavengerAssetEvents,
    ScavengerAssetMetering,
    ImageGallery,
    ScvAlertsTemplate,
    ScavengerAssetReport,
    ArcGIS,
    TooltipVT,
    CustomOverlay,
  },
  data: function () {
    return {
      show: true,
      temp_min_max: {
        min: null,
        max: null,
      },
      drawer: false,
      from_min: true,
      in_sync: true,
      startDate: null,
      endDate: null,
      flat: true,
      multiple: true,
      no_search: true,
      network_error: false,
      page_content: null,
      journeys_list: null,
      stats_data: null,
      messages_list: null,
      current_tab: "Charts",
      device_data: null,
      previous_device_data: {},
      changed_device_data: {},
      current_position: {},
      current_battery_icon: "battery-full",
      last_start_date: null,
      device_id: "",
      location_data: {},
      device_id_comparision: null,
      show_info_window: true,
      dialog: false,
      show_map_object: null,
      duration: null,
      stats_data_comparison: null,
      overlay_type: null,
      show_comparision_data: false,
      brushing: true,
      show_individual_feeders: false,
      show_rms_charts: false,
      as_of: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      show_as_of: false,
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
      weather_data: null,
      selected_prop: ["Mean"],
      chart_fields: [],
      common_comparision_data: null,
      formatted_stats_data: null,
      formatted_stats_comparision_data: null,
      show_ambient_temp: false,
      ambient_temp_list: null,
      daily_stats_data: null,
      chartZoomed: null,
      chart_voltage_data: null,
      chart_current_data: null,
      chart_thd_data: null,
      active: [],
      activeCharts: [],
      open: ["feeder", "feeder_1"],
      gallery_images: null,
      show_events: true,
      prev_data: false,
      active_feeders: null,
      active_tenant: null,
      chart_shortcut: null,
      messages_shortcut: null,
      trends_shortcut: null,
      events_shortcut: null,
      metering_shortcut: null,
      images_shortcut: null,
      reporting_shortcut: null,
      previous_message_timestamp: null,
      latest_message_timestamp: null,
      test_state: 0,
      previous_state: 0,
      aggregation_period: null, // 3 seconds to delay the API call
      data_call_interval: null,
      time_update_interval: null,
      last_call_time_display: null,
      last_message_time_display: null,
      last_call_timestamp: null,
      asset_data_stream: null,
      snackbar: false,
      error_message: "",
      charts_data: [],
      raw_data: [],
      overview_data: [],
      scavenger_data: [],
    };
  },
  async created() {
    await this.$store.dispatch("fetchPowerdataType");
    this.active_tenant = this.$store.getters.getPowerDataType;
    this.page_content = this.active_tenant == "h2scan" ? h2Content : content;
    this.duration = this.page_content.chart_select[0];
    this.$nextTick(() => {
      this.getScavengerDetails();
      this.$store.commit("setCurrentDevice", this.device_id);
      this.startAssetDataStream(); //TODO: Start the stream only if the current tenant is activated for livestream
    });
    this.time_update_interval = setInterval(() => {
      // Update the time display every 30 seconds
      this.last_message_time_display = moment(parseInt(this.latest_message_timestamp)).fromNow();
      this.last_call_time_display = moment(this.last_call_timestamp).fromNow();
    }, 30000);
  },
  methods: {
    fadeClass(key) {
      return key.fade ? "titleLight--text text--lighten-5 text-caption" : "";
    },
    getStateValue(state) {
      return this[state];
    },
    isChanged(key) {
      return key in this.changed_device_data;
    },
    closeDialog(event) {
      this.$store.commit("setUpdateAlerts", true);
      this.dialog = false;
      this.overlay_type = "";
      if (event && event.msg) {
        this.error_message = event.msg;
        this.snackbar = true;
      }
    },
    openNewAlertsDialog() {
      this.$store.commit("setUpdateAlerts", false);
      this.dialog = true;
      this.overlay_type = "alert";
    },
    clear_charts() {
      this.show_individual_feeders = false;
    },
    update_data_asof() {
      this.prev_data = true;
      //this.getScavengerDetails();
    },
    async fetch_today_temp_data() {
      if (this.device_data.CurrentLat && this.device_data.CurrentLng) {
        this.dialog = false;
        this.overlay_type = "";
        this.network_error = false;
        const response = await axios_get(weather.fetch_today_temp_data, {
          lat: this.device_data.CurrentLat,
          lng: this.device_data.CurrentLng,
        });
        this.weather_data = response;
      }
    },
    async getScavengerDetails() {
      this.last_call_timestamp = Date.now();
      this.last_call_time_display = moment(this.last_call_timestamp).fromNow();
      await this.getDeviceDetails();
      this.getScavengerOverview();
    },
    getDay(day) {
      return this.$config.days[day];
    },
    update_current_tab(val) {
      this.current_tab = val;
    },
    get_missing_count(data) {
      var prev_seq = null;
      var last_valid_seq = null;
      var count_missing = 0;
      for (var i = data.length - 1; i >= 0; i--) {
        count_missing = 0;
        if (i != data.length - 1) {
          if (prev_seq != null && last_valid_seq != null && data[i].SeqNo != 0) {
            count_missing = ((data[i].SeqNo - 1) % 4096) - last_valid_seq;
          }
          if (data[i].SeqNo == 0) {
            count_missing = "-";
            data[i]["UpdatedSeqNo"] =
              data[i]["PacketType"] && data[i]["PacketType"].toLowerCase().includes("gprs") ? "GPRS" : "LTE";
          } else {
            data[i]["UpdatedSeqNo"] = data[i].SeqNo;
          }
        }
        prev_seq = data[i].SeqNo;
        if (data[i].SeqNo != 0) {
          last_valid_seq = data[i].SeqNo;
        }
        data[i]["CountMissing"] = count_missing;
      }
      data[data.length - 1]["CountMissing"] = 0;
      return data;
    },
    exportPDF() {
      //this.$store.commit("show_loader");
      var opt = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "poi_snapshot_" + new Date().toString() + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.poisnapshot)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function () {
          //Customization
        })
        .save();
      window.setTimeout(() => {
        this.dialog = false;
        this.overlay_type = "";
        this.$store.commit("hide_loader");
      }, 1000);
    },
    async update_assets_details(data) {
      this.dialog = false;
      this.network_error = false;
      const {
        DeviceID,
        TransformerName,
        AssetID,
        TransformerNo,
        TransformerRating,
        CurrentLat,
        CurrentLng,
        Comment,
        ConnectedMPRNs,
        ConnectionType,
      } = data;
      if (TransformerRating && this.device_data.TransformerRating != TransformerRating) {
        await axios_put(trafo.update_assets_details, { DeviceID }, { PowerRating: TransformerRating });
      }
      await axios_post(scv.update_scv_details, data, {
        DeviceID,
      });
      this.error_message = "Device Details Successfully Saved!";
      this.device_data = {
        ...this.device_data,
        TransformerName,
        AssetID,
        TransformerNo,
        TransformerRating,
        CurrentLat,
        CurrentLng,
        Comment,
        ConnectedMPRNs,
        ConnectionType,
      };
      this.snackbar = true;
    },
    async getDeviceDetails() {
      this.network_error = false;
      if (this.$route.params && this.$route.params.deviceId) {
        this.no_search = false;
        this.device_id = this.$route.params.deviceId;
        this.$store.commit("clear_search");
      } else {
        this.device_id = this.deviceId;
      }
      const params =
        this.as_of != this.today_timestamp
          ? {
              start_date: this.$timestampToEpoch(new Date(new Date(this.as_of).getTime() + 60 * 60 * 24 * 1000 - 1)),
            }
          : null;

      // const response = await axios_get(
      //   scv.get_scavenger_data,
      //   {
      //     id: this.device_id,
      //   },
      //   params
      // );
      const response = await scavenger_grpc_services.GetScavengerData(this.device_id, params);
      this.device_data = this.compareData(response.length > 0 ? response[0] : {});
      this.$store.commit("update_page_title", `Device / ${this.device_data.AssetID || this.device_id}`);
      // Aggregation period is in minutes, so converting it to milliseconds
      this.aggregation_period = this.device_data.AggregationPeriod
        ? this.device_data.AggregationPeriod * 60000 + 3000
        : 63000;
      this.active_feeders = this.device_data.ActiverFeeders ? this.device_data.ActiverFeeders.toString() : null;
      this.latest_message_timestamp = this.getMessageTimestamp();
    },
    getMessageTimestamp() {
      return this.device_data ? this.device_data.Timestamp : null;
    },
    async getScavengerOverview() {
      this.network_error = false;
      // const response = await axios_get(scv.get_scavenger_overview, {
      //   id: this.device_id,
      // });
      const response = await scavenger_grpc_services.GetScavengerOverview(this.device_id);
      if (response && response[0]) {
        this.device_data["UL1"] = response[0]["UL1"];
        this.device_data["UL2"] = response[0]["UL2"];
        this.device_data["UL3"] = response[0]["UL3"];
      }
    },
    brush: function () {
      this.show_individual_feeders = true;
    },
    redirectToAutocon: function () {
      let path = this.current_coordinates
        ? `/autocon/${this.current_coordinates.lat},${this.current_coordinates.lng}`
        : `/autocon/`;
      let routeData = this.$router.resolve({
        path: path,
      });
      window.open(routeData.href, "_blank");
    },
    compareData(newData) {
      this.changed_device_data = {}; // Reset changed data

      // Compare new data with previous data
      for (const key in newData) {
        if (newData[key] !== this.previous_device_data[key]) {
          this.changed_device_data[key] = newData[key];
        }
      }

      // Update previous data
      this.previous_device_data = { ...newData };
      return newData;
    },
    getMissedMessageType(percentage) {
      if (percentage >= 0 && percentage <= 1) {
        return "good";
      } else if (percentage > 1 && percentage <= 10) {
        return "average";
      } else {
        return "bad";
      }
    },
    startAssetDataStream() {
      let payload = {};
      payload.device_id = this.device_id;
      payload.scavenger_data = true;
      payload.minlist_data = true;
      payload.scavenger_overview = true;
      payload.chart_data = true;
      this.asset_data_stream = scavenger_grpc_services.GetScavengerAssetDataStream(payload);
      this.asset_data_stream.on("data", (response) => {
        // console.log("asset data streaming", response.toObject().assetData);
        const realtime_data = response.toObject().assetData;
        this.charts_data = realtime_data.chartDataList;
        this.raw_data = realtime_data.minlistDataList;
        this.overview_data = realtime_data.scavengerOverviewList;
        this.scavenger_data = [realtime_data.scavengerData];
      });
    },
    getTooltipText(data, config) {
      return config.tooltip_value
        ? config.tooltip_text + this.$options.filters.date(data[config.tooltip_value])
        : config.tooltip_text;
    },
  },
  computed: {
    missed_message_percentage() {
      return this.device_data.MissedMessages
        ? this.$percentageOf(this.device_data.MissedMessages, this.device_data.ExpectedMessageCount)
        : null;
    },
    missed_message_icon() {
      return this.$config.MissedMessageTypes[this.getMissedMessageType(this.missed_message_percentage)].icon;
    },
    missed_message_color() {
      return this.$config.MissedMessageTypes[this.getMissedMessageType(this.missed_message_percentage)].color;
    },
    is_h2_device_type: function () {
      return this.active_tenant == "h2scan" && this.device_data.Type == "h2";
    },
    tabs: function () {
      if (!this.active_tenant) return [];
      let temp = [];
      let tabs_arr =
        this.$store.state.tenant_config &&
        this.$store.state.tenant_config.asset_tabs &&
        this.$store.state.tenant_config.asset_tabs.map((elem) => elem.id);
      this.page_content.tabs.map((elem) => {
        if (
          tabs_arr &&
          tabs_arr.indexOf(elem.id) != -1 &&
          this.$store.state.tenant_config.asset_tabs[tabs_arr.indexOf(elem.id)]["show"] &&
          (!this.$store.state.user_config.asset_tabs || this.$store.state.user_config.asset_tabs.indexOf(elem.id) != -1)
        ) {
          temp.push(elem.label);
        }
      });
      return temp;
    },
    is_tester: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("Tester") != -1 ? true : false;
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      return temp_obj;
    },
    map_data: function () {
      return this.device_data.CurrentLat && this.device_data.CurrentLng ? [this.device_data] : null;
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
    current_coordinates: function () {
      return this.map_data
        ? { lat: this.computed_location_details.CurrentLat, lng: this.computed_location_details.CurrentLng }
        : null;
    },
    computed_as_of() {
      return this.as_of ? this.$formatDateAsOf(this.as_of) : null;
    },
    today_timestamp() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
    },
    last_message() {
      return this.latest_message_time;
    },
    use_arcgis: function () {
      let use_arcgis = this.$store.state.tenant_config && this.$store.state.tenant_config.use_arcgis;
      return use_arcgis;
    },
    redirectProps() {
      return {
        redirect_label: this.active_tenant == "h2scan" ? "DGA" : "Net Zero",
        redirect_route: this.active_tenant == "h2scan" ? `/scavenger_h2/${this.device_id}` : `/asset/${this.device_id}`,
      };
    },
    is_readonly_user: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("ReadOnlyUser") != -1 ? true : false;
    },
    has_location() {
      return this.device_data && this.device_data.CurrentLat && this.device_data.CurrentLng ? true : false;
    },
  },
  beforeDestroy() {
    // Clear interval when component is destroyed
    clearInterval(this.data_call_interval);
    clearInterval(this.time_update_interval);
    this.asset_data_stream.cancel();
  },
};
</script>

<style lang="scss" scoped>
.device_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}

.border-bottom {
  border-bottom: 1px solid var(--v-restingOutline-base);
}

.border-right {
  border-right: 1px solid var(--v-restingOutline-base);
}

.duration_select_div {
  .duration_select {
    width: 9em;
    margin-right: 1em;
  }

  .asset_select {
    width: 25em;

    .v-input {
      max-width: 80%;
    }
  }

  ::v-deep.show-ambient-temp {
    label {
      margin-bottom: 0 !important;
    }
  }
}

::v-deep .export-div {
  top: 25px;
  right: 2rem;
}

.pointer {
  cursor: pointer;
}
.autocon-con {
  position: absolute;
  z-index: 9;
  right: 1.2em;
  top: 1.2em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-enter {
  opacity: 0;
  background-color: transparent;
}

.fade-enter-to {
  opacity: 1;
  background-color: transparent;
}

.fade-leave {
  opacity: 1;
  background-color: #0582c650;
}

.fade-leave-to {
  opacity: 0;
  background-color: #0582c650;
}

span {
  display: inline-block;
  border-radius: 8px;
}
</style>
